import './style.scss'

import Image from 'components/Image'

export default {
  name: 'Images',
  props: ['componentData'],
  render (h) {
    const { componentData } = this
    return (
      <div class='Images'>
        {componentData.map(i => (
          <Image src={i.image} caption={i.caption ? i.caption : ''} alt={i.image.alt ? i.image.alt : (i.caption ? i.caption : '')} fullWidth={i.image_size === 'full'} />
        ))}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./client/components/Images/index.js